import { authTokenGet, authTokenSet } from "@codestreet/utils";
import { apiRequest } from "./client";
import type { ApiRequestHeaders, ApiRequestOptions } from "./client.types";
import type { ApiResponseRefreshToken } from "./client.types";

const REFRESH_URL = "/refresh";

export async function requestRefresh(
  authURL: string,
  headers: ApiRequestHeaders,
  options?: ApiRequestOptions,
): Promise<boolean> {
  const token = authTokenGet();

  if (!token) return false;

  const formData = new FormData();
  formData.append("access_token", token.accessToken);
  formData.append("refresh_token", token.refreshToken);

  const requestURL = new URL(authURL + REFRESH_URL);

  const response = await apiRequest<ApiResponseRefreshToken>(
    requestURL,
    "POST",
    formData,
    headers,
    options,
  );

  if (response.isOk && response.data) {
    const { accessToken, refreshToken } = response.data;

    authTokenSet({
      accessToken,
      refreshToken,
      expiresAt: response.data.expires,
    });

    return true;
  }

  return false;
}
